// extracted by mini-css-extract-plugin
export default {"footer":"qfJi6U"};